import { Session } from '@/api/types/Session';
import { Profile } from '@/api/types/Profile';

const state = {
  session: null as Session | null,
  profile: null as Profile | null
};

export type StateType = typeof state;
export default state;
